import Image from 'next/image';
import * as LogoBlack from '@/public/logo-black.svg';
import * as LogoWhite from '@/public/logo-white.svg';
import * as LogoYellow from '@/public/logo-yellow.svg';

import { cn } from '@/lib/utils';

export function Logo({
  size = 'md',
  color = 'black',
  className,
}: {
  size?: 'md' | 'lg';
  color?: 'black' | 'white' | 'yellow';
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex items-center gap-2 text-lg font-semibold md:text-base w-36',
        size === 'lg' && 'w-36',
        className
      )}
    >
      <Image
        src={color === 'black' ? LogoBlack : color === 'white' ? LogoWhite : LogoYellow}
        className={`md:w-${size === 'md' ? '32' : '36'} h-auto block w-full`}
        alt="Kawkb's Logo"
        loading="eager"
        unoptimized={true}
      />
    </div>
  );
}
